import { createSelector } from 'reselect'

const scheduleSelector = state => state.approvals.schedule

export {
    scheduleSelector
}